.readonlyList {
  .container {
    position: relative;
    overflow: hidden;

    .emptyMessage {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      .content {
        z-index: 1;
      }

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: var(--ixf-color-background);
        opacity: 0.8;
      }
    }
  }
}
